export default __webpack_public_path__ + "static/media/artistBanner3.10b22221.png";